// Domaca valuta ovisi o poslovnoj godini: do zakljucno 2022. knjizilo se u
// kunama, od 2023. u eurima.
//
// Provjera "godina &&" nije visak. Usporedba se pisala i bez nje, a JavaScript
// tada racuna ovako:
//
//   null <= 2022   ->  null postane 0  ->  tocno   ->  Kn
//   0    <= 2022   ->                      tocno   ->  Kn
//
// Znaci: kad poslovne godine nema, ekran bi ponudio kune i tecaj 7,5345. Kad
// godina nije poznata, ispravno je uzeti danasnju valutu, a ne onu od prije.

const uKunama = (godina) => !!(godina && godina <= 2022)

const domacaValuta = (godina) => uKunama(godina) ? 'Kn' : 'EUR'

const tecajValute = (godina) => uKunama(godina) ? 7.5345 : 1

export { uKunama, domacaValuta, tecajValute }
export default domacaValuta
